import { ETipoOperacao } from '../../../../../../enums/ETipoOperacao';
import { IOperacaoOutrosRegimesBaseCalculoResumo } from '../../../../../../interfaces/IOperacoes';
import BaseDeCalculoAccordion from './components/baseDeCalculoAccordion/baseDeCalculoAccordion';

interface IBaseDeCalculoAccordionListProps {
  listaComponentesBaseCalculoResumo: IOperacaoOutrosRegimesBaseCalculoResumo;
}

function BaseDeCalculoAccordionList({ listaComponentesBaseCalculoResumo }: IBaseDeCalculoAccordionListProps) {
  return (
    <>
      <BaseDeCalculoAccordion
        baseCalculo={ETipoOperacao.BALNEARIO}
        listaComponentesBaseCalculoResumo={listaComponentesBaseCalculoResumo.balnearioOutrosValores}
      />
      <BaseDeCalculoAccordion
        baseCalculo={ETipoOperacao.BALNEARIO}
        listaComponentesBaseCalculoResumo={listaComponentesBaseCalculoResumo.balnearioValorBanho}
      />
      <BaseDeCalculoAccordion
        baseCalculo={ETipoOperacao.RECEITA_BRUTA_TRIBUTOS_INCIDENTES}
        listaComponentesBaseCalculoResumo={listaComponentesBaseCalculoResumo.receitaBrutaVendas}
      />
      <BaseDeCalculoAccordion
        baseCalculo={ETipoOperacao.VENDA_TERRITORIO_NACIONAL_EMPRESAS_COLIGADAS_OU_MESMO_GRUPO_ECONOMICO}
        listaComponentesBaseCalculoResumo={listaComponentesBaseCalculoResumo.vendaNacionalEmpresaMesmoGrupo}
      />
      <BaseDeCalculoAccordion
        baseCalculo={ETipoOperacao.RECEITA_BRUTA_CALCULADA}
        listaComponentesBaseCalculoResumo={listaComponentesBaseCalculoResumo.receitaBrutaCalculada}
      />
      <BaseDeCalculoAccordion
        baseCalculo={ETipoOperacao.RECEITA_CALCULADA_EXPORTACOES}
        listaComponentesBaseCalculoResumo={listaComponentesBaseCalculoResumo.receitaCalculadaExportacoes}
      />
    </>
  );
}

export default BaseDeCalculoAccordionList;
